import { z } from "zod";
import { defineRoute } from "../http/route.js";
/**
 * OpenIM's answer to a callback: `nextCode` 1 with an error code refuses the operation, 0 lets it through. An answer
 * that lets an operation through echoes the request's fields, because OpenIM v3.8 copies some answer fields over the
 * request even when they are empty (a rename would otherwise lose its group id).
 */
export const OpenImCallbackAnswer = z.looseObject({
    actionCode: z.literal(0),
    errCode: z.number().int(),
    errMsg: z.string(),
    errDlt: z.string(),
    nextCode: z.union([z.literal(0), z.literal(1)]),
});
/**
 * OpenIM asks the platform before every structural change and every message (ADR 0016 points 2 and 3). The secret
 * in the path is the only credential OpenIM can present; the endpoint is reachable only from OpenIM's network.
 */
export const openimCallback = defineRoute({
    id: "internal.openim.callback",
    method: "POST",
    path: "/internal/openim/{secret}/{command}",
    surface: "internal",
    auth: "signature",
    permission: "none",
    marks: [],
    summary: "Decide an OpenIM operation before OpenIM carries it out",
    prd: ["IM-1", "IM-5"],
    request: {
        params: z.object({
            secret: z.string().min(1).max(200),
            command: z.string().regex(/^callback[A-Za-z]{4,80}Command$/),
        }),
        body: z.record(z.string(), z.unknown()),
    },
    responses: { 200: { description: "The decision", schema: OpenImCallbackAnswer } },
    errors: ["NOT_FOUND", "VALIDATION_FAILED"],
});
export const openimCallbackRoutes = [openimCallback];
//# sourceMappingURL=openim-callback.routes.js.map